export const LOCAL_STORAGE_STATE_KEY = 'hiqGlobalState'

export class LocalStorage {
  private static isEnabled: boolean = typeof localStorage !== 'undefined'
  private storageKey: string

  constructor(storageKey: string = '') {
    this.storageKey = `${LOCAL_STORAGE_STATE_KEY}${storageKey ? '-' + storageKey : ''}`
  }

  getAll(): Record<string, any> {
    if (LocalStorage.isEnabled) {
      try {
        const stateStr = localStorage.getItem(this.storageKey)
        return stateStr && JSON.parse(stateStr)
      } catch(e) {
        return {}
      }
    }
    return {}
  }

  removeAll(): void {
    if (LocalStorage.isEnabled) {
      localStorage.removeItem(this.storageKey)
    }
  }

  updateAll(state: Record<string, any>): void {
    if (LocalStorage.isEnabled) {
      localStorage.setItem(this.storageKey, JSON.stringify(state))
    }
  }

  setItem(name: string, value: any): void {
    if (LocalStorage.isEnabled) {
      const allItems = this.getAll()
      const newItems = {
        ...allItems,
        [name]: value
      }
      localStorage.setItem(this.storageKey, JSON.stringify(newItems))
    }
  }

  getItem(name: string): string | null {
    if (LocalStorage.isEnabled) {
      const allItems = this.getAll()
      return allItems && allItems[name]
    }
    return null
  }
}
